import React from "react";
import { CircleCheck, ShieldCheck, MapPin } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutKhakiPlumbing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="7683" id="why-choose-our-structural-deck-services" className="bg-background text-foreground py-24 overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20 items-center">
          {}
          <div className={`relative isolate transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            {}
            <div className="absolute inset-0 translate-x-4 translate-y-4 rounded-sm border border-foreground z-0 hidden md:block" aria-hidden="true" />
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/khaki_plumbing_team_action.png" alt="Structural concrete deck engineering and construction" className="relative z-10 h-full w-full rounded-sm object-cover shadow-xl bg-muted aspect-[4/3]" />
          </div>

          {}
          <div className={`flex flex-col gap-8 transition-all duration-700 delay-300 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="flex flex-wrap gap-3">
              <Badge variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest px-3 py-1 text-xs font-bold font-default">
                Engineering
              </Badge>
              <Badge variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest px-3 py-1 text-xs font-bold font-default">
                CA-Seismic
              </Badge>
              <Badge variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest px-3 py-1 text-xs font-bold font-default">
                Licensed
              </Badge>
            </div>

            <div className="space-y-4">
              <h2 className="text-3xl font-bold tracking-tighter text-foreground sm:text-4xl lg:text-5xl font-default">
                Structural Deck Mastery
              </h2>
              <p className="text-lg font-medium text-foreground/90 font-default">
                Precision engineering and concrete expertise for California's most demanding architectural landscapes since 1990.
              </p>
            </div>

            <div className="space-y-4 text-base text-muted-foreground font-default leading-relaxed">
              <p>
                At PCH Builders, we specialize in the complex structural engineering required for elevated and concrete decks. Our team has mastered the unique challenges of building on Northern California's hillsides, ensuring every project meets rigorous seismic safety codes and local building regulations.
              </p>
              <p>
                We provide a comprehensive service that includes structural engineering, full permit acquisition, and expert installation. Our concrete and structural decks are built to last generations, combining industrial-grade durability with the architectural elegance PCH Builders is known for across the region.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
              {[{
              icon: ShieldCheck,
              text: "CA Seismic Compliance"
            }, {
              icon: CircleCheck,
              text: "Engineering Standards"
            }, {
              icon: MapPin,
              text: "SF & Santa Clara Counties"
            }, {
              icon: CircleCheck,
              text: "Full Permit Management"
            }].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                  <item.icon className="h-5 w-5 text-primary shrink-0" />
                  <span className="text-sm font-semibold text-foreground font-default">
                    {item.text}
                  </span>
                </div>)}
            </div>

            <div className="pt-4 flex flex-wrap gap-4">
              <Button size="lg" className="font-bold bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm" asChild>
                <Link to="#">Request Site Visit</Link>
              </Button>
              <Button size="lg" variant="outline" className="font-bold border-foreground text-foreground hover:bg-accent rounded-sm" asChild>
                <Link to="#">Our Service Areas</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}